export default "__VITE_ASSET__cui9P3hY__"